import { render, staticRenderFns } from "./ReligionsFilter.vue?vue&type=template&id=6f696199&"
import script from "./ReligionsFilter.vue?vue&type=script&lang=js&"
export * from "./ReligionsFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports